import React, { useState, useEffect } from 'react';
import { RotateCcw, Shuffle, CheckCircle, X, Lightbulb, Trophy, Star, Award, Crown } from 'lucide-react';

const ClickWordGame = () => {
  // 单词词典 - 包含单词和中文释义
  const wordDictionary = {
    'CAT': '猫', 'DOG': '狗', 'SUN': '太阳', 'RUN': '跑', 'FUN': '乐趣',
    'BAT': '蝙蝠', 'HAT': '帽子', 'RAT': '老鼠', 'BIG': '大的', 'RED': '红色', 'DIM': '昏暗的', 'MUD': '泥土',
    'HOT': '热的', 'TOP': '顶部', 'CUP': '杯子', 'PEN': '笔', 'BOX': '盒子',
    'FOX': '狐狸', 'SEA': '大海', 'SKY': '天空', 'EYE': '眼睛', 'EAR': '耳朵',
    'ARM': '手臂', 'LEG': '腿', 'BAG': '包', 'CAR': '汽车', 'BED': '床',
    'EGG': '鸡蛋', 'ICE': '冰', 'KEY': '钥匙', 'NET': '网', 'OIL': '油',
    'PIE': '馅饼', 'ZOO': '动物园', 'PET': '宠物', 'SET': '设置', 'GET': '得到',
    'LET': '让', 'MET': '遇见', 'BET': '打赌', 'WET': '湿的', 'JET': '喷气机',
    'SIT': '坐', 'HIT': '打击', 'BIT': '咬', 'FIT': '合适', 'KIT': '工具包',
    'LIT': '点燃', 'PIT': '坑', 'WIT': '智慧', 'CUT': '切', 'BUT': '但是',
    'NUT': '坚果', 'HUT': '小屋', 'PUT': '放', 'GUT': '肠子', 'JUT': '突出',
    'TUT': '啧啧', 'BUD': '花蕾', 'FUR': '毛皮', 'BUR': '刺果',
    'PUR': '呼噜声', 'AGE': '年龄', 'ARE': '是', 'ATE': '吃了', 'USE': '使用',
    'ONE': '一', 'TWO': '二', 'SIX': '六', 'TEN': '十', 'NEW': '新的',
    'OLD': '老的', 'BAD': '坏的', 'SAD': '悲伤', 'MAD': '疯狂', 'DAD': '爸爸',
    'MOM': '妈妈', 'SON': '儿子', 'TON': '吨', 'CON': '骗子', 'DON': '穿上',
    'ION': '离子', 'WON': '赢了', 'TOM': '汤姆', 'BOB': '鲍勃', 'ROY': '罗伊',
    'JOE': '乔', 'ANN': '安', 'SUE': '苏', 'AMY': '艾米', 'YES': '是的', 'WIN': '赢', 'END': '结束',
    'TRY': '尝试', 'WHY': '为什么', 'WAY': '路', 'DAY': '天', 'BOY': '男孩',
    'TOY': '玩具', 'JOY': '快乐', 'COW': '奶牛', 'NOW': '现在', 'HOW': '怎么',
    'LOW': '低的', 'ROW': '行', 'TOW': '拖', 'EAT': '吃', 'FAT': '胖的',
    'SAT': '坐了', 'MAT': '垫子', 'PAT': '拍', 'VAT': '桶', 'TAT': '粗麻布',
    'LAT': '纬度', 'FLY': '飞', 'DRY': '干的', 'CRY': '哭', 'FRY': '炸',
    'SPY': '间谍', 'SHY': '害羞', 'BUY': '买', 'HOP': '跳', 'POP': '爆炸', 'MOP': '拖把',
    'COP': '警察', 'SOP': '浸泡', 'LOB': '高球', 'JOB': '工作', 'DIG': '挖',
    'PIG': '猪', 'WIG': '假发', 'FIG': '无花果', 'JIG': '夹具', 'RIG': '装备',
    'LOG': '木头', 'FOG': '雾', 'HOG': '猪', 'JOG': '慢跑', 'NOG': '蛋酒',
    'TOG': '衣服', 'COG': '齿轮', 'BOG': '沼泽', 'GOD': '神', 'ROD': '杆',
    'NOD': '点头', 'SOD': '草皮', 'COD': '鳕鱼', 'POD': '豆荚', 'MOD': '时髦',
    'TOD': '狐狸', 'LOD': '细节', 'YOU': '你', 'HER': '她的', 'HIM': '他',
    'HIS': '他的', 'SHE': '她', 'HEE': '嘻', 'WHO': '谁', 'THE': '这个',
    'FOR': '为了', 'AND': '和', 'CAN': '能够', 'MAY': '可能', 'ALL': '全部',
    'ANY': '任何', 'OUR': '我们的', 'OUT': '出去', 'SEE': '看', 'SAY': '说',
    'GOT': '得到', 'HAS': '有', 'HAD': '有过', 'WAS': '是', 'GAS': '汽油',
    'NOT': '不', 'TOO': '也', 'FAR': '远', 'OFF': '关闭', 'OWN': '自己的', 'MAN': '男人',
    'MEN': '男人们', 'BOW': '弓', 'LAW': '法律', 'RAW': '生的', 'SAW': '锯子',
    'PAW': '爪子', 'JAW': '下巴', 'TAX': '税', 'WAX': '蜡', 'MAX': '最大',
    'MIX': '混合', 'FIX': '修理', 'SOX': '袜子', 'LOX': '熏鲑鱼', 'POX': '痘',
    'VEX': '烦恼', 'HEX': '六角形', 'AWE': '敬畏', 'WOE': '痛苦', 'FEW': '少数',
    'DEW': '露水', 'SEW': '缝纫', 'JEW': '犹太人', 'PEW': '教堂长椅', 'MEW': '猫叫',
    'YEW': '紫杉', 'EWE': '母羊', 'ORE': '矿石', 'OWE': '欠', 'OWL': '猫头鹰',
    'OAK': '橡树', 'OAR': '桨', 'OAT': '燕麦', 'AWL': '锥子', 'OPT': '选择',
    'ORB': '球体', 'ODD': '奇怪', 'OFT': '经常', 'BID': '出价', 'RID': '摆脱',
    'LID': '盖子', 'KID': '孩子', 'DID': '做了', 'AID': '帮助', 'LAD': '小伙子',
    'PAD': '垫子', 'TAD': '一点点', 'WAD': '一团', 'TAG': '标签', 'NOB': '门把手', 'SOB': '哭泣',
    'ROB': '抢劫', 'MOB': '暴民', 'COB': '玉米芯', 'GOB': '嘴', 'HOB': '炉灶',
    'FOB': '表链', 'BAY': '海湾', 'HAY': '干草', 'LAY': '放置', 'PAY': '付钱',
    'RAY': '光线', 'GAY': '快乐', 'JAY': '松鸦', 'LAB': '实验室', 'TAB': '标签',
    'CAB': '出租车', 'DAB': '轻拍', 'FAB': '极好的', 'GAB': '闲聊', 'JAB': '戳',
    'NAB': '抓住', 'RAB': '兔子', 'SAB': '破坏', 'CAP': '帽子', 'GAP': '间隙',
    'LAP': '大腿', 'MAP': '地图', 'NAP': '小睡', 'RAP': '说唱', 'SAP': '树液',
    'TAP': '轻拍', 'ZAP': '攻击', 'TAR': '焦油', 'BAR': '酒吧',
    'JAR': '罐子', 'MAR': '损坏', 'PAR': '标准', 'WAR': '战争',
    'BEE': '蜜蜂', 'FEE': '费用', 'LEE': '背风处', 'TEE': '球座', 'WEE': '小的',
    'PEE': '小便', 'GEE': '哎呀', 'PEA': '豌豆', 'TEA': '茶',
    'LEA': '草地', 'BEA': '比亚', 'ERA': '时代', 'SPA': '温泉', 'BRA': '胸罩',
    'TOE': '脚趾', 'HOE': '锄头', 'DOE': '母鹿',
    'ROE': '鱼卵', 'FOE': '敌人', 'WOK': '炒锅', 'INK': '墨水',
    'IRK': '烦恼', 'ILL': '生病', 'INN': '客栈', 'IRE': '愤怒'
  };

  const validWords = Object.keys(wordDictionary);

  // 元音和辅音字母分组
  const vowels = ['A', 'E', 'I', 'O', 'U'];
  const consonants = ['B', 'C', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'R', 'S', 'T', 'W', 'Y'];
  
  // 初始化3x3网格，严格控制2个不同元音字母，U最多出现一次
  const initializeGrid = () => {
    const grid = [];
    const letters = [];
    
    // 严格添加2个不同的元音字母，U最多出现一次
    const selectedVowels = [];
    while (selectedVowels.length < 2) {
      const vowel = vowels[Math.floor(Math.random() * vowels.length)];
      if (!selectedVowels.includes(vowel)) {
        selectedVowels.push(vowel);
      }
    }
    
    // 如果包含U，确保只添加一个U
    const finalVowels = [];
    let hasU = false;
    
    selectedVowels.forEach(vowel => {
      if (vowel === 'U') {
        if (!hasU) {
          finalVowels.push(vowel);
          hasU = true;
        } else {
          // 如果已经有U了，用其他元音替换
          const otherVowels = vowels.filter(v => v !== 'U' && !finalVowels.includes(v));
          if (otherVowels.length > 0) {
            finalVowels.push(otherVowels[Math.floor(Math.random() * otherVowels.length)]);
          }
        }
      } else {
        finalVowels.push(vowel);
      }
    });
    
    letters.push(...finalVowels);
    
    // 添加7个辅音字母
    for (let i = 0; i < 7; i++) {
      letters.push(consonants[Math.floor(Math.random() * consonants.length)]);
    }
    
    // 打乱数组
    for (let i = letters.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [letters[i], letters[j]] = [letters[j], letters[i]];
    }
    
    // 创建网格
    let letterIndex = 0;
    for (let i = 0; i < 3; i++) {
      const row = [];
      for (let j = 0; j < 3; j++) {
        row.push({
          id: `${i}-${j}`,
          letter: letters[letterIndex++],
          row: i,
          col: j,
          isSelected: false,
          selectionOrder: 0
        });
      }
      grid.push(row);
    }
    return grid;
  };

  const [grid, setGrid] = useState(initializeGrid);
  const [selectedCells, setSelectedCells] = useState([]);
  const [score, setScore] = useState(0);
  const [foundWords, setFoundWords] = useState([]);
  const [currentWord, setCurrentWord] = useState('');
  const [message, setMessage] = useState('');
  const [achievements, setAchievements] = useState([]); // 成就系统
  const [showRules, setShowRules] = useState(false); // 规则弹窗状态

  // 级别系统配置
  const levels = [
    { score: 0, title: '新手', icon: Lightbulb, color: 'text-gray-500', bgColor: 'bg-gray-100' },
    { score: 100, title: '学徒', icon: Star, color: 'text-blue-500', bgColor: 'bg-blue-100' },
    { score: 200, title: '熟练', icon: Award, color: 'text-green-500', bgColor: 'bg-green-100' },
    { score: 400, title: '专家', icon: Trophy, color: 'text-purple-500', bgColor: 'bg-purple-100' },
    { score: 600, title: '大师', icon: Crown, color: 'text-yellow-500', bgColor: 'bg-yellow-100' },
    { score: 1000, title: '传奇', icon: Crown, color: 'text-red-500', bgColor: 'bg-red-100' },
  ];

  // 获取当前级别
  const getCurrentLevel = () => {
    for (let i = levels.length - 1; i >= 0; i--) {
      if (score >= levels[i].score) {
        return { ...levels[i], index: i };
      }
    }
    return { ...levels[0], index: 0 };
  };

  // 获取下一级别
  const getNextLevel = () => {
    const currentLevel = getCurrentLevel();
    if (currentLevel.index < levels.length - 1) {
      return levels[currentLevel.index + 1];
    }
    return null;
  };

  // 检查是否达到新级别
  const checkLevelUp = (newScore) => {
    // 检查是否跨越了新的级别阈值
    for (let i = levels.length - 1; i >= 0; i--) {
      if (newScore >= levels[i].score && score < levels[i].score) {
        const newLevel = levels[i];
        const timestamp = Date.now();
        
        setAchievements(prev => [...prev, { 
          type: 'levelUp', 
          title: newLevel.title, 
          icon: newLevel.icon,
          timestamp: timestamp
        }]);
        
        // 3秒后移除这个特定的成就通知
        setTimeout(() => {
          setAchievements(prev => prev.filter(a => a.timestamp !== timestamp));
        }, 3000);
        
        break; // 只处理一个级别升级
      }
    }
  };

  // 获取按键样式，元音字母特殊样式
  const getButtonStyle = (isSelected, letter) => {
    const isVowel = vowels.includes(letter);
    
    if (isSelected) {
      // 按下状态：轻微下沉，边框变薄，内阴影
      if (isVowel) {
        return `
          bg-amber-200 text-orange-600
          border-t-2 border-l-2 border-r-3 border-b-3 
          border-amber-400
          shadow-inner transform translate-y-1
          shadow-amber-500/30
        `;
      } else {
        return `
          bg-gray-200 text-cyan-600
          border-t-2 border-l-2 border-r-3 border-b-3 
          border-gray-400
          shadow-inner transform translate-y-1
          shadow-gray-500/30
        `;
      }
    } else {
      // 凸起状态：按键高起，厚边框，外阴影
      if (isVowel) {
        return `
          bg-amber-100 text-orange-500
          border-t-4 border-l-4 border-r-6 border-b-6 
          border-t-amber-50 border-l-amber-50 border-r-amber-400 border-b-amber-500
          shadow-lg shadow-amber-600/40 transform translate-y-0
          hover:translate-y-0.5 active:translate-y-1 active:shadow-inner
          transition-all duration-150
        `;
      } else {
        return `
          bg-gray-100 text-cyan-500
          border-t-4 border-l-4 border-r-6 border-b-6 
          border-t-gray-50 border-l-gray-50 border-r-gray-400 border-b-gray-500
          shadow-lg shadow-gray-600/40 transform translate-y-0
          hover:translate-y-0.5 active:translate-y-1 active:shadow-inner
          transition-all duration-150
        `;
      }
    }
  };

  // 处理方块点击
  const handleCellClick = (cell) => {
    if (cell.isSelected) {
      // 如果已经选中，则取消选择
      const newGrid = grid.map(row => 
        row.map(c => 
          c.id === cell.id 
            ? { ...c, isSelected: false, selectionOrder: 0 }
            : c.selectionOrder > cell.selectionOrder 
              ? { ...c, selectionOrder: c.selectionOrder - 1 }
              : c
        )
      );
      
      setGrid(newGrid);
      setSelectedCells(prev => prev.filter(c => c.id !== cell.id));
    } else if (selectedCells.length < 3) {
      // 选择新方块
      const newGrid = grid.map(row => 
        row.map(c => 
          c.id === cell.id 
            ? { ...c, isSelected: true, selectionOrder: selectedCells.length + 1 }
            : c
        )
      );
      
      setGrid(newGrid);
      setSelectedCells(prev => [...prev, cell]);
    }
  };

  // 检查选中的字母是否组成有效单词
  const checkSelectedWord = async () => {
    if (selectedCells.length === 3) {
      // 按选择顺序排列字母
      const sortedCells = [...selectedCells].sort((a, b) => {
        const cellA = grid.flat().find(c => c.id === a.id);
        const cellB = grid.flat().find(c => c.id === b.id);
        return cellA.selectionOrder - cellB.selectionOrder;
      });
      
      const word = sortedCells.map(cell => cell.letter).join('');
      setCurrentWord(word);
      
      let isValid = false;
      let meaning = '';
      
      // 首先检查本地词典
      if (validWords.includes(word)) {
        isValid = true;
        meaning = wordDictionary[word];
      } else {
        // 如果本地没有，调用API验证
        try {
          setMessage('正在验证单词...');
          const response = await fetch(`/api/letters-3-len.php?word=${word}`);
          const data = await response.json();
          
          if (data.success && data.meaning) {
            isValid = true;
            meaning = data.meaning;
          }
        } catch (error) {
          console.log('API调用失败，使用本地词典:', error);
        }
      }
      
      if (isValid) {
        // 找到有效单词
        const isNewWord = !foundWords.some(item => item.word === word);
        const points = isNewWord ? 20 : 10; // 新单词20分，重复单词10分
        
        setMessage(`太棒了！拼出了单词: ${word} (${meaning}) +${points}分`);
        
        const newScore = score + points;
        checkLevelUp(newScore);
        setScore(newScore);
        
        // 只有新单词才添加到已发现列表
        if (isNewWord) {
          setFoundWords(prev => [{ word, meaning }, ...prev]); // 新单词放在第一位
        }
        
        // 分析消除单词中的元音字母
        const removedVowels = [];
        
        sortedCells.forEach(cell => {
          if (vowels.includes(cell.letter)) {
            removedVowels.push(cell.letter);
          }
        });
        
        // 替换选中的字母
        setTimeout(() => {
          const newGrid = grid.map(row => 
            row.map(cell => {
              if (cell.isSelected) {
                let newLetter;
                if (vowels.includes(cell.letter)) {
                  // 如果是元音位置，必须用元音替换，但避免使用刚消除的元音
                  // 同时确保U不重复出现
                  const currentVowelsInGrid = grid.flat()
                    .filter(c => !c.isSelected && vowels.includes(c.letter))
                    .map(c => c.letter);
                  
                  let availableVowels = vowels.filter(v => !removedVowels.includes(v));
                  
                  // 如果网格中已经有U，且当前要替换的不是U，则排除U
                  if (currentVowelsInGrid.includes('U') && cell.letter !== 'U') {
                    availableVowels = availableVowels.filter(v => v !== 'U');
                  }
                  
                  if (availableVowels.length > 0) {
                    newLetter = availableVowels[Math.floor(Math.random() * availableVowels.length)];
                  } else {
                    // 如果所有元音都被排除，随机选择一个元音（但仍避免重复U）
                    const fallbackVowels = currentVowelsInGrid.includes('U') && cell.letter !== 'U' 
                      ? vowels.filter(v => v !== 'U')
                      : vowels;
                    newLetter = fallbackVowels[Math.floor(Math.random() * fallbackVowels.length)];
                  }
                } else {
                  // 如果是辅音位置，必须用辅音替换，同时考虑Z的限制
                  const currentZCount = grid.flat()
                    .filter(c => !c.isSelected && c.letter === 'Z')
                    .length;
                  
                  // 如果网格中已经有Z，且当前要替换的不是Z，则不能生成Z
                  if (currentZCount > 0 && cell.letter !== 'Z') {
                    newLetter = consonants[Math.floor(Math.random() * consonants.length)];
                  } else {
                    // 10% 概率生成Z，90% 概率生成普通辅音
                    if (Math.random() < 0.1) {
                      newLetter = 'Z';
                    } else {
                      newLetter = consonants[Math.floor(Math.random() * consonants.length)];
                    }
                  }
                }
                
                return {
                  ...cell,
                  letter: newLetter,
                  isSelected: false,
                  selectionOrder: 0
                };
              }
              return { ...cell, isSelected: false, selectionOrder: 0 };
            })
          );
          
          setGrid(newGrid);
          setSelectedCells([]);
          setCurrentWord('');
          setMessage('');
        }, 1500);
      } else {
        // 不是有效单词
        setMessage(`${word} 不是有效单词，再试试！`);
        
        // 3秒后自动清除选择和消息
        setTimeout(() => {
          setMessage('');
          clearSelection();
        }, 3000);
      }
    }
  };

  // 清除选择
  const clearSelection = () => {
    const newGrid = grid.map(row => 
      row.map(cell => ({ ...cell, isSelected: false, selectionOrder: 0 }))
    );
    setGrid(newGrid);
    setSelectedCells([]);
    setCurrentWord('');
    setMessage('');
  };

  // 重新排列当前字母的位置
  const shuffleCurrentLetters = () => {
    // 获取当前所有字母
    const currentLetters = grid.flat().map(cell => cell.letter);
    
    // 打乱字母顺序
    for (let i = currentLetters.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [currentLetters[i], currentLetters[j]] = [currentLetters[j], currentLetters[i]];
    }
    
    // 重新分配到网格中
    const newGrid = [];
    let letterIndex = 0;
    for (let i = 0; i < 3; i++) {
      const row = [];
      for (let j = 0; j < 3; j++) {
        row.push({
          id: `${i}-${j}`,
          letter: currentLetters[letterIndex++],
          row: i,
          col: j,
          isSelected: false,
          selectionOrder: 0
        });
      }
      newGrid.push(row);
    }
    
    setGrid(newGrid);
    setSelectedCells([]);
    setCurrentWord('');
    setMessage('');
  };

  // 重置游戏
  const resetGame = () => {
    setGrid(initializeGrid());
    setSelectedCells([]);
    setScore(0);
    setFoundWords([]);
    setCurrentWord('');
    setMessage('');
    setAchievements([]);
  };

  // 更新当前拼写的单词
  useEffect(() => {
    if (selectedCells.length > 0) {
      const sortedCells = [...selectedCells].sort((a, b) => {
        const cellA = grid.flat().find(c => c.id === a.id);
        const cellB = grid.flat().find(c => c.id === b.id);
        return cellA.selectionOrder - cellB.selectionOrder;
      });
      const word = sortedCells.map(cell => cell.letter).join('');
      setCurrentWord(word);
    } else {
      setCurrentWord('');
    }
  }, [selectedCells, grid]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-purple-400 to-blue-600 p-2 sm:p-4 lg:p-6 xl:p-8">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-sm sm:max-w-md lg:max-w-2xl xl:max-w-4xl 2xl:max-w-6xl mx-auto" 
           style={{ 
             padding: 'clamp(12px, 3vw, 48px)',
             maxWidth: 'min(1200px, 90vw)'
           }}>
        {/* 级别升级通知 */}
        {achievements.map((achievement, index) => (
          <div key={achievement.timestamp} className="fixed top-16 sm:top-20 lg:top-24 xl:top-32 left-1/2 transform -translate-x-1/2 z-50 bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-4 sm:px-6 xl:px-8 py-2 sm:py-3 xl:py-4 rounded-full shadow-lg animate-bounce">
            <div className="flex items-center gap-2 xl:gap-3">
              {React.createElement(achievement.icon, { className: "w-4 h-4 sm:w-5 h-5 lg:w-6 lg:h-6 xl:w-8 xl:h-8" })}
              <span className="font-bold text-sm sm:text-base xl:text-lg">升级到 {achievement.title}！</span>
            </div>
          </div>
        ))}

        <div className="text-center mb-2 sm:mb-3 xl:mb-6">
          <div className="flex items-center justify-center relative">
            <h1 className="text-lg sm:text-xl lg:text-3xl xl:text-4xl 2xl:text-5xl font-black bg-gradient-to-r from-purple-600 via-pink-500 to-blue-600 bg-clip-text text-transparent mb-1 xl:mb-2">
              拼词消消乐
            </h1>
            {/* 规则提示按钮 */}
            <button
              onClick={() => setShowRules(true)}
              className="absolute right-0 top-0 flex items-center gap-1 bg-blue-100 hover:bg-blue-200 text-blue-600 px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 hover:scale-105"
              style={{ fontSize: 'clamp(0.625rem, 0.8vw, 0.75rem)' }}
            >
              <Lightbulb className="w-3 h-3" />
              <span>规则</span>
            </button>
          </div>
          <div className="w-9 sm:w-12 lg:w-15 xl:w-24 2xl:w-30 h-0.5 sm:h-0.5 xl:h-1.5 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full mx-auto"></div>
        </div>

        {/* 规则弹窗 */}
        {showRules && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-xl max-w-md w-full max-h-96 overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold text-gray-800">游戏规则</h2>
                  <button
                    onClick={() => setShowRules(false)}
                    className="text-gray-500 hover:text-gray-700 transition-colors"
                  >
                    <X className="w-6 h-6" />
                  </button>
                </div>
                
                <div className="space-y-4 text-sm text-gray-600">
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-2">🎯 游戏玩法</h3>
                    <ul className="space-y-1 ml-2">
                      <li>• 依次点击3个字母拼成英文单词</li>
                      <li>• 数字显示点击顺序</li>
                      <li>• 点击已选字母可取消选择</li>
                      <li>• 每局限制：U、Z最多出现一次</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-2">📊 计分规则</h3>
                    <ul className="space-y-1 ml-2">
                      <li>• 新单词：+20分</li>
                      <li>• 重复单词：+10分</li>
                      <li>• 无效单词：0分</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-2">🏆 级别系统</h3>
                    <ul className="space-y-1 ml-2">
                      <li>• 新手：0分</li>
                      <li>• 学徒：100分</li>
                      <li>• 熟练：200分</li>
                      <li>• 专家：400分</li>
                      <li>• 大师：600分</li>
                      <li>• 传奇：1000分</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-2">💡 小贴士</h3>
                    <ul className="space-y-1 ml-2">
                      <li>• 元音字母（A,E,I,O,U）用黄色标识</li>
                      <li>• 可使用"重新排列"功能调整字母位置</li>
                      <li>• 已发现单词会显示在下方列表中</li>
                    </ul>
                  </div>
                </div>
                
                <div className="mt-6 flex justify-end">
                  <button
                    onClick={() => setShowRules(false)}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-medium transition-colors"
                  >
                    开始游戏
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        
        {/* 级别和分数显示 */}
        <div className="flex items-center justify-between mb-2 sm:mb-3 xl:mb-6">
          <div className={`flex items-center gap-1 sm:gap-1.5 xl:gap-3 px-2 sm:px-2.5 xl:px-4.5 py-0.5 sm:py-1 xl:py-2 rounded-full ${getCurrentLevel().bgColor}`}>
            {React.createElement(getCurrentLevel().icon, { 
              className: `w-3 h-3 sm:w-4 h-4 lg:w-5 lg:h-5 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7 ${getCurrentLevel().color}` 
            })}
            <span className={`text-xs sm:text-sm lg:text-sm xl:text-lg 2xl:text-xl font-semibold ${getCurrentLevel().color}`}>
              {getCurrentLevel().title}
            </span>
          </div>
          
          <div className="flex items-center gap-1 sm:gap-1.5 xl:gap-3 text-base sm:text-lg lg:text-xl xl:text-3xl 2xl:text-4xl font-bold text-blue-600">
            <Trophy className="w-2.5 h-2.5 sm:w-3 h-3 lg:w-4 h-4 xl:w-5 xl:h-5 2xl:w-7 2xl:h-7" />
            <span>{score}</span>
          </div>
        </div>
        
        {/* 进度条 */}
        {getNextLevel() && (
          <div className="mb-2 sm:mb-3 xl:mb-6">
            <div className="flex justify-between items-center mb-0.5 sm:mb-0.5 xl:mb-2">
              <span className="text-xs sm:text-sm lg:text-sm xl:text-base 2xl:text-lg text-gray-600">距离 {getNextLevel().title}</span>
              <span className="text-xs sm:text-sm lg:text-sm xl:text-base 2xl:text-lg text-gray-600">{getNextLevel().score - score}分</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-0.5 sm:h-1 lg:h-1.5 xl:h-3">
              <div 
                className="bg-gradient-to-r from-blue-500 to-purple-500 h-0.5 sm:h-1 lg:h-1.5 xl:h-3 rounded-full transition-all duration-500"
                style={{ 
                  width: `${Math.min(100, ((score - getCurrentLevel().score) / (getNextLevel().score - getCurrentLevel().score)) * 100)}%` 
                }}
              ></div>
            </div>
          </div>
        )}
        
        {/* 当前拼写的单词 - 优化显示 */}
        <div className="text-center mb-3 sm:mb-4 xl:mb-8 h-6 sm:h-8 lg:h-10 xl:h-12 2xl:h-14">
          {currentWord && (
            <div 
              className="text-lg sm:text-xl lg:text-2xl xl:text-2xl 2xl:text-3xl font-black tracking-wider"
              style={{ fontSize: 'clamp(1.125rem, 1.8vw, 1.8rem)' }}
            >
              <span className="text-gray-400">当前单词: </span>
              <span className="text-purple-600">{currentWord}</span>
            </div>
          )}
        </div>
        
        {/* 消息提示 */}
        <div className="text-center mb-3 sm:mb-4 xl:mb-8 h-4 sm:h-5 lg:h-6 xl:h-8 2xl:h-10">
          {message && (
            <div className={`text-xs sm:text-sm lg:text-base xl:text-lg 2xl:text-xl font-bold ${
              message.includes('太棒了') ? 'text-green-600' : 'text-red-600'
            }`}>
              {message}
            </div>
          )}
        </div>
        
        {/* 3x3游戏网格 - 优化大屏显示 */}
        <div className="flex justify-center items-center mb-3 sm:mb-4 xl:mb-8 bg-gradient-to-br from-gray-200 to-gray-300 p-3 sm:p-4 lg:p-6 xl:p-8 2xl:p-10 rounded-xl sm:rounded-2xl shadow-inner">
          <div 
            className="grid grid-cols-3 gap-2 sm:gap-3 lg:gap-4 xl:gap-5 2xl:gap-6"
            style={{ gap: 'clamp(8px, 1.2vw, 24px)' }}
          >
            {grid.map((row, rowIndex) =>
              row.map((cell, colIndex) => (
                <div
                  key={cell.id}
                  className={`
                    w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 xl:w-32 xl:h-32 2xl:w-36 2xl:h-36
                    flex items-center justify-center 
                    rounded-lg sm:rounded-xl xl:rounded-2xl cursor-pointer
                    font-black text-xl sm:text-2xl md:text-3xl lg:text-3xl xl:text-4xl 2xl:text-5xl
                    transition-all duration-200
                    relative select-none
                    ${getButtonStyle(cell.isSelected, cell.letter)}
                  `}
                  style={{
                    width: 'clamp(64px, 4.5vw, 120px)',
                    height: 'clamp(64px, 4.5vw, 120px)',
                    fontSize: 'clamp(1.25rem, 2.2vw, 2.8rem)'
                  }}
                  onClick={() => handleCellClick(cell)}
                >
                  {/* 字母 */}
                  <span className="relative z-10 leading-none drop-shadow-sm" style={{ 
                    fontFamily: 'system-ui, -apple-system, sans-serif'
                  }}>
                    {cell.letter}
                  </span>
                  
                  {/* 选择顺序数字 */}
                  {cell.isSelected && (
                    <div 
                      className="absolute -top-0.5 -right-0.5 sm:-top-1 sm:-right-1 xl:-top-1.5 xl:-right-1.5 2xl:-top-2 2xl:-right-2 w-5 h-5 sm:w-6 sm:h-6 lg:w-7 lg:h-7 xl:w-8 xl:h-8 2xl:w-9 2xl:h-9 flex items-center justify-center text-xs sm:text-sm lg:text-base xl:text-base 2xl:text-lg font-bold text-white bg-red-500 rounded-full border-2 xl:border-2 2xl:border-3 border-white shadow-lg"
                      style={{
                        width: 'clamp(20px, 1.2vw, 32px)',
                        height: 'clamp(20px, 1.2vw, 32px)',
                        fontSize: 'clamp(0.75rem, 0.8vw, 1rem)'
                      }}
                    >
                      {cell.selectionOrder}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
        
        {/* 检查单词按钮 */}
        <div className="mb-3 sm:mb-4 xl:mb-8">
          <button
            onClick={checkSelectedWord}
            disabled={selectedCells.length !== 3}
            className={`w-full flex items-center justify-center gap-2 xl:gap-4 font-bold rounded-lg xl:rounded-2xl transition-all duration-200 ${
              selectedCells.length === 3
                ? 'bg-green-500 text-white hover:bg-green-600 hover:scale-105 shadow-lg'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
            style={{
              padding: 'clamp(10px, 1.2vw, 20px) clamp(12px, 2vw, 32px)',
              fontSize: 'clamp(0.875rem, 1.2vw, 1.25rem)'
            }}
          >
            <CheckCircle 
              className="flex-shrink-0"
              style={{
                width: 'clamp(16px, 1.8vw, 28px)',
                height: 'clamp(16px, 1.8vw, 28px)'
              }}
            />
            <span>检查单词</span>
          </button>
        </div>
        
        {/* 其他操作按钮 */}
        <div className="grid grid-cols-3 gap-1.5 sm:gap-2 lg:gap-3 xl:gap-4 mb-3 sm:mb-4 xl:mb-8">
          <button
            onClick={resetGame}
            className="flex items-center justify-center gap-1 xl:gap-2 bg-red-50 text-red-600 font-semibold rounded-lg xl:rounded-2xl border-2 border-red-100 hover:border-red-200 hover:bg-red-100 transition-all duration-200 hover:scale-105 shadow-sm"
            style={{
              padding: 'clamp(6px, 1vw, 16px) clamp(4px, 0.8vw, 16px)',
              fontSize: 'clamp(0.75rem, 1vw, 1rem)'
            }}
          >
            <RotateCcw 
              className="flex-shrink-0"
              style={{
                width: 'clamp(12px, 1.2vw, 20px)',
                height: 'clamp(12px, 1.2vw, 20px)'
              }}
            />
            <span>重新开始</span>
          </button>
          <button
            onClick={shuffleCurrentLetters}
            className="flex items-center justify-center gap-1 xl:gap-2 bg-blue-50 text-blue-600 font-semibold rounded-lg xl:rounded-2xl border-2 border-blue-100 hover:border-blue-200 hover:bg-blue-100 transition-all duration-200 hover:scale-105 shadow-sm"
            style={{
              padding: 'clamp(6px, 1vw, 16px) clamp(4px, 0.8vw, 16px)',
              fontSize: 'clamp(0.75rem, 1vw, 1rem)'
            }}
          >
            <Shuffle 
              className="flex-shrink-0"
              style={{
                width: 'clamp(12px, 1.2vw, 20px)',
                height: 'clamp(12px, 1.2vw, 20px)'
              }}
            />
            <span>重新排列</span>
          </button>
          <button
            onClick={clearSelection}
            className="flex items-center justify-center gap-1 xl:gap-2 bg-orange-50 text-orange-600 font-semibold rounded-lg xl:rounded-2xl border-2 border-orange-100 hover:border-orange-200 hover:bg-orange-100 transition-all duration-200 hover:scale-105 shadow-sm"
            style={{
              padding: 'clamp(6px, 1vw, 16px) clamp(4px, 0.8vw, 16px)',
              fontSize: 'clamp(0.75rem, 1vw, 1rem)'
            }}
          >
            <X 
              className="flex-shrink-0"
              style={{
                width: 'clamp(12px, 1.2vw, 20px)',
                height: 'clamp(12px, 1.2vw, 20px)'
              }}
            />
            <span>清除选择</span>
          </button>
        </div>
        
        {/* 已发现的单词 */}
        {foundWords.length > 0 && (
          <div className="mb-3 sm:mb-4 xl:mb-8">
            <h3 className="flex items-center gap-1.5 sm:gap-2 xl:gap-4 text-xs sm:text-sm lg:text-base xl:text-xl 2xl:text-2xl font-bold text-gray-700 mb-1.5 sm:mb-2 xl:mb-4">
              <Trophy className="w-3 h-3 sm:w-4 h-4 lg:w-5 h-5 xl:w-8 xl:h-8 2xl:w-10 2xl:h-10 text-yellow-500" />
              已发现单词 ({foundWords.length}):
            </h3>
            <div 
              className="flex flex-wrap gap-1 sm:gap-1.5 xl:gap-4 overflow-y-auto p-1.5 sm:p-2 xl:p-4 bg-gray-50 rounded-lg xl:rounded-2xl"
              style={{ 
                minHeight: 'clamp(80px, 8vh, 120px)',
                maxHeight: 'clamp(120px, 12vh, 180px)'
              }}
            >
              {foundWords.map((item, index) => (
                <div 
                  key={index} 
                  className="bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded xl:rounded-xl font-medium shadow-md transform hover:scale-105 transition-all duration-200 border border-purple-500 flex flex-col justify-center items-center text-center"
                  style={{
                    width: 'clamp(60px, 3.5vw, 80px)',
                    height: 'clamp(60px, 3.5vw, 80px)',
                    padding: 'clamp(4px, 0.3vw, 6px)'
                  }}
                >
                  <div 
                    className="font-bold leading-tight"
                    style={{ fontSize: 'clamp(0.75rem, 0.8vw, 0.9rem)' }}
                  >
                    {item.word}
                  </div>
                  <div 
                    className="text-purple-100 leading-tight mt-1"
                    style={{ fontSize: 'clamp(0.625rem, 0.7vw, 0.8rem)' }}
                  >
                    {item.meaning}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClickWordGame;